import { useQuery } from "@tanstack/react-query";
import { fetchEngagements } from "../api/engagements";

export function useEngagements() {
  return useQuery({
    queryKey: ["engagements"],
    queryFn: fetchEngagements,
  });
}
